<template>
  <v-app>
    <AppBar v-if="isLoggedIn"> </AppBar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-snackbar
      v-model="snackbar.open"
      :color="snackbar.color"
      :multi-line="true"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="
            toggleSnackbar({
              open: false,
              color: null,
              text: null,
            })
          "
        >
          Κλείσιμο
        </v-btn>
      </template>
    </v-snackbar>

    <Footer v-if="isLoggedIn"></Footer>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import axios from "axios";
import AppBar from "./components/AppBar.vue";
import Footer from "./components/Footer.vue";

export default {
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState({
      token: (state) => state.auth.token,
    }),

    snackbar: {
      get() {
        return this.$store.state.base.snackbar;
      },

      set(newValue) {
        this.toggleSnackbar(newValue);
      },
    },
  },

  created() {
    if (this.isLoggedIn) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${this.token}`;
    }

    axios.interceptors.response.use(
      (res) => {
        return res;
      },
      (err) => {
        if (err.response.status === 401) {
          this.logout().then(() => {
            this.$router.push({ path: "/login" });
          });
        }
        throw err;
      }
    );
  },
  methods: {
    ...mapMutations(["toggleSnackbar"]),
    ...mapActions(["logout"]),
  },
  components: {
    AppBar,
    Footer,
  },
};
</script>

<style lang="scss">
//======VUETIFY OVERRIDES========
.v-main__wrap {
  display: flex;
}

.v-input__slot,
.v-label {
  font-size: 16px !important;
}

.v-input--is-disabled .v-input--selection-controls__input .v-icon::before {
  // color: var(--v-primary-base) !important;
}

.theme--light.v-btn.v-btn--disabled.button1 {
  color: var(--v-secondary-base) !important;
}

// .v-alert__content {
//   width: 950px !important;
// }

@media only screen and (max-width: 600px) {
  .v-alert__content {
    width: 100% !important;
    font-size: 15px !important;
  }
}

@media only screen and (max-width: 960px) {
  .v-alert__content {
    width: 100% !important;
    font-size: 15px !important;
  }
}

span {
  // padding: 0 20px;
  text-transform: none !important;
  word-break: keep-all !important;
}

tr:hover {
  background: none !important;
}

//======GLOBAL STYLES=======
.component-wrapper {
  flex-grow: 1;
  padding: 20px;
}

@media only screen and (max-width: 600px) {
  .component-wrapper {
    padding: 10px;
  }
  .v-input__slot,
  .v-label {
    font-size: 15px !important;
  }
}
</style>
